import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
//
import Scrollbar from '../../../../components/Scrollbar';
import ChatMessageItem from './ChatMessageItem';

// ----------------------------------------------------------------------

ChatMessageList.propTypes = {
  messages: PropTypes.array.isRequired,
};

export default function ChatMessageList({ messages }) {
  const scrollRef = useRef(null);

  useEffect(() => {
    const scrollMessagesToBottom = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    };
    scrollMessagesToBottom();
  }, [messages]);

  const aux = {};

  (messages ?? []).forEach((msg) => {
    if (!aux[msg.id_usuario]) {
      aux[msg.id_usuario] = {
        id_usuario: msg.id_usuario,
        usuario: msg.usuario,
      };
    }
  });

  const participants = [];

  Object.keys(aux).forEach((key) => participants.push(aux[key]));

  return (
    <>
      <Scrollbar
        scrollableNodeProps={{ ref: scrollRef }}
        sx={{ p: 3, height: 1 }}
      >
        {messages.map((message, index) => (
          <ChatMessageItem
            key={`${message.fecha}_${index}`}
            message={message}
            participants={participants}
          />
        ))}
      </Scrollbar>
    </>
  );
}
